import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { PRODUCT_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function ProductTypeList({
  productTypeList,
  getProductTypeList,
  setEditProductTypeDetails,
  setShowAddForm,
}) {
  const onClickEdit = (productType) => {
    setEditProductTypeDetails(productType);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [productTypeDeleteId, setProductTypeDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", productTypeDeleteId);
    try {
      let response = "";
      if (productTypeDeleteId) {
        response = await axios.post(`${PRODUCT_TYPE_CONFIG_URL}/delete`, {
          product_type_id: productTypeDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast(
          "Product Type details has been deleted successfully.",
          "success"
        );
        getProductTypeList();
      } else {
        showToast("Product Type details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setProductTypeDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Product Type Name
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {productTypeList?.length > 0 &&
          productTypeList?.map((productType, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {productType.product_type_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(productType)}
                    aria-label="Edit Product Type Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setProductTypeDeleteId(
                        productType?.product_type_id || null
                      );
                      setShowDelete(true);
                    }}
                    aria-label="Delete Product Type Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
